import { Alert, Box } from '@mui/material';
import { Save } from '@mui/icons-material';

import {
  CustomButton,
  DrawerForm,
  DrawerFormActionSummary,
  DrawerFormActions,
  DrawerFormSidebar,
} from '../../../common/components';
import { invoiceSections } from '../constants/supplierLedgerUiConstants';
import useSupplierInvoiceDialogController from '../hooks/useSupplierInvoiceDialogController';
import { formatCurrencyAmount } from '../utils/supplierLedgerFormatters';
import SupplierInvoiceActiveSection from './supplier-invoice/SupplierInvoiceActiveSection';

const SupplierInvoiceDialog = ({ open, onClose, providers, invoiceToEdit = null }) => {
  const {
    activeSection,
    amountLines,
    amountTotals,
    accountingAccountOptions,
    accountingAccountsLoading,
    currentAttachmentName,
    error,
    file,
    form,
    handleAddAmountLine,
    handleAmountLineChange,
    handleChange,
    handleClose,
    handleRemoveAmountLine,
    handleSubmit,
    isEditMode,
    isSaving,
    locksFinancialFields,
    movementConceptOptions,
    movementConceptsLoading,
    providerOptions,
    selectedProviderName,
    setActiveSection,
    setFile,
  } = useSupplierInvoiceDialogController({
    invoiceToEdit,
    onClose,
    open,
    providers,
  });

  return (
    <DrawerForm
      open={open}
      onClose={handleClose}
      title={isEditMode ? 'Editar factura de proveedor' : 'Nueva factura de proveedor'}
      sidebar={(
        <DrawerFormSidebar
          sections={invoiceSections}
          activeSection={activeSection}
          onSelect={setActiveSection}
        />
      )}
      footer={(
        <DrawerFormActions
          summary={(
            <DrawerFormActionSummary
              label="Total a registrar"
              value={formatCurrencyAmount(amountTotals.total, form.currency)}
            />
          )}
        >
          <CustomButton variant="outlined" onClick={handleClose}>Cancelar</CustomButton>
          <CustomButton
            variant="base"
            startIcon={<Save />}
            onClick={handleSubmit}
            disabled={amountTotals.total <= 0}
            isLoading={isSaving}
          >
            {isEditMode ? 'Guardar cambios' : 'Guardar factura'}
          </CustomButton>
        </DrawerFormActions>
      )}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1, md: 1.25 }, minWidth: 0 }}>
        {error && (
          <Box sx={{ mx: { xs: 1.25, md: 2 } }}>
            <Alert severity="error">{error}</Alert>
          </Box>
        )}
        <SupplierInvoiceActiveSection
          activeSection={activeSection}
          amountLines={amountLines}
          amountTotals={amountTotals}
          accountingAccountOptions={accountingAccountOptions}
          accountingAccountsLoading={accountingAccountsLoading}
          currentAttachmentName={currentAttachmentName}
          file={file}
          form={form}
          isEditMode={isEditMode}
          locksFinancialFields={locksFinancialFields}
          movementConceptOptions={movementConceptOptions}
          movementConceptsLoading={movementConceptsLoading}
          onAddAmountLine={handleAddAmountLine}
          onAmountLineChange={handleAmountLineChange}
          onChange={handleChange}
          onFileChange={setFile}
          onRemoveAmountLine={handleRemoveAmountLine}
          providerOptions={providerOptions}
          selectedProviderName={selectedProviderName}
        />
      </Box>
    </DrawerForm>
  );
};

export default SupplierInvoiceDialog;
